module.exports = __webpack_public_path__ + "img/ren_3.6f0c9949.webp";